// router/index.js
import { useRoutes } from "react-router-dom";
import MainLayout from "../components/MainLayout";
import { AccountActivityControl, AccountActivityDetail, AccountActivityIndex } from "../pages/accountActivity/";
import { AccountListDetail, AccountListIndex } from "../pages/accountList";
import CompanyDataReg from "../pages/accountManagement/CompanyDataReg";
import { SubAccountControl, SubAccountDetail, SubAccountIndex } from "../pages/accountManagement/SubAccount/";
import { ActivityAnalyze, ActivityAnalyzeIndex } from "../pages/analyze/";
import { Cache, CacheIndex } from "../pages/cache/";
import { Carbon, CarbonDetail, CarbonEditFile, CarbonIndex, CarbonReport } from "../pages/carbonFootprint";
import ActivityData_Detail from "../pages/carbonFootprint/components/ActivityData_Detail";
import EvaluationTempSetting from "../pages/carbonFootprint/components/EvaluationTempSetting";
import { Cbam, CbamDetail, CbamIndex } from "../pages/cbam/";
import EmissionSourceFactor from "../pages/emissionSourceFactor/emissionSourceFactor";
import {
  CompanyBinding,
  CompanyBindingActivate,
  CompanyBindingCooperate,
  CompanyBindingDetail,
  CompanyBindingIndex,
} from "../pages/companyBinding";
import CompanyDataSetting from "../pages/companyDataSet/CompanyDataSetting";
import CompanyFile from "../pages/companyfile/CompanyFile";
import { CompanyList, CompanyListAcct, CompanyListIndex, CompanyListRoleMapping } from "../pages/companyList";
import { CompanyOffering, CompanyOfferingCreate, CompanyOfferingIndex } from "../pages/companyOffering";
import { CompanyStatsList, CompanyStatsListIndex, CompanyStatusListDetail } from "../pages/companyStatsList/";
import { DashboardMain } from "../pages/dashboard/dashboardMain";
import DashboardParent from "../pages/dashboard/DashboardParent";
import DataReg_Index from "../pages/dataRegistration/DataReg_Index";
import {
  EquipmentProcessSettings,
  EquipmentProcessSettingsDetail,
  EquipmentProcessSettingsIndex,
} from "../pages/equipmentProcessSettings/";
import { FuncList, FuncListDetail, FuncListIndex, FuncListRoleDetail } from "../pages/funcList";
import {
  FootprintInventoryIndex,
  InventoryCarbonFootprint,
  InventoryCarbonFootprintCreate,
  InventoryCarbonFootprintEditFile,
  InventoryCarbonFootprintIndex,
  InventoryCarbonFootprintReport,
} from "../pages/inventoryCarbonFootprint";
import CarbonFootprintDashboard from "../pages/inventoryCarbonFootprint/cusComponents/CarbonFootprintDashboard";
import { InviteRecord, InviteRecordCreate, InviteRecordDetail, InviteRecordIndex } from "../pages/inviteRecord";
import Landing from "../pages/Landing";
import ForgetAccPwd from "../pages/login/ForgetAccPwd";
import Idpsso from "../pages/login/Idpsso/Idpsso";
import Ldap from "../pages/login/ldap/Ldap";
import MLdap from "../pages/login/ldap/MLdap";
import Login from "../pages/login/Login";
import MemberPermissionSetting from "../pages/memberPermission/MemberPermissionSetting";
import NotFound from "../pages/NotFound";
import { NoticeRecord, NoticeRecordCreate, NoticeRecordIndex } from "../pages/noticeRecord";
import OperationGuide from "../pages/operationGuide/operationGuide";
import ChangePcode from "../pages/personal/ChangePcode";
import PersonalProfile from "../pages/personal/PersonalProfile";
import PlaceMaintain from "../pages/placeMaintain/PlaceMaintain";
import { ProductCarbonFootprintIndex } from "../pages/productCarbonFootprint";
import ProductCarbonFootprint from "../pages/productCarbonFootprint/ProductCarbonFootprint";
import {
  ProductProcessSettings,
  ProductProcessSettingsDetail,
  ProductProcessSettingsIndex,
} from "../pages/productProcessSettings/";
import Register from "../pages/Register";
import RegisterInvite from "../pages/RegisterInvite";
import {
  AccessControl,
  AccessControlIndex,
  RoleFunctionMaintain,
  RoleGroup,
  RolePlaceMaintain,
  RoleProductMaintain,
} from "../pages/rolePermission/";
import { ServiceCarbonFootprintIndex } from "../pages/serviceCarbonFootprint";
import ServiceCarbonFootprint from "../pages/serviceCarbonFootprint/ServiceCarbonFootprint";
import { Setting, SettingDetail, SettingIndex } from "../pages/setting";
import { UserDashboard, UserDashboardIndex } from "../pages/userDashboard/";
import { BoundaryDevice, BoundaryDeviceIndex, BoundaryDeviceDetail } from "../pages/boundaryDevice";

const HandleRoutesPath = () => {
  const routes = useRoutes([
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/index.html",
      element: <Login />,
    },
    {
      path: "/register/:issuer?",
      element: <Register />,
    },
    {
      path: "/register/invite/:issuer?",
      element: <RegisterInvite />,
    },
    {
      path: "/forgetaccpwd",
      element: <ForgetAccPwd />,
    },
    { path: "/ldap", element: <Ldap /> },
    {
      path: "/mldap",
      element: <MLdap />,
    },
    {
      path: "/idpsso/:type",
      element: <Idpsso />,
    },
    {
      path: "/management",
      element: <MainLayout />,
      children: [
        {
          path: "funcList",
          element: <FuncList />,
          children: [
            {
              index: true,
              element: <FuncListIndex />,
            },
            {
              path: "detail",
              element: <FuncListDetail />,
            },
            {
              path: "roledetail",
              element: <FuncListRoleDetail />,
            },
          ],
        },
        {
          path: "noticeRecord",
          element: <NoticeRecord />,
          children: [
            {
              index: true,
              element: <NoticeRecordIndex />,
            },
            {
              path: "create",
              element: <NoticeRecordCreate />,
            },
            {
              path: "detail",
              element: <NoticeRecordCreate />,
            },
          ],
        },
        {
          path: "companyList",
          element: <CompanyList />,
          children: [
            {
              index: true,
              element: <CompanyListIndex />,
            },
            {
              path: "detail",
              element: <CompanyBindingDetail backToUrl="companyList" />,
            },
            {
              path: "roleMapping",
              element: <CompanyListRoleMapping />,
            },
            {
              path: "acct",
              children: [
                {
                  index: true,
                  element: <CompanyListAcct />,
                },
                {
                  path: "detail",
                  element: <AccountListDetail backToUrl="companyList/acct" />,
                },
              ],
            },
          ],
        },
        {
          path: "companyBinding",
          element: <CompanyBinding />,
          children: [
            {
              index: true,
              element: <CompanyBindingIndex />,
            },
            {
              path: "detail",
              element: <CompanyBindingDetail />,
            },
            {
              path: "activate",
              element: <CompanyBindingActivate />,
            },
            {
              path: "extend",
              element: <CompanyBindingActivate actStatus="0" />,
            },
            {
              path: "cooperate",
              element: <CompanyBindingCooperate />,
            },
          ],
        },
        {
          path: "inviteRecord",
          element: <InviteRecord />,
          children: [
            {
              index: true,
              element: <InviteRecordIndex />,
            },
            {
              path: "create",
              element: <InviteRecordCreate />,
            },
            {
              path: "detail",
              element: <InviteRecordDetail />,
            },
          ],
        },
        {
          path: "accountList",
          element: <InviteRecord />,
          children: [
            {
              index: true,
              element: <AccountListIndex />,
            },
            {
              path: "detail",
              element: <AccountListDetail />,
            },
          ],
        },
        {
          path: "companyFile",
          element: <CompanyFile />,
        },
        {
          path: "placeMaintain",
          element: <PlaceMaintain />,
        },
        {
          path: "companyDataSetting",
          element: <CompanyDataSetting />,
        },
        {
          path: "companyOffering",
          element: <CompanyOffering />,
          children: [
            {
              index: true,
              element: <CompanyOfferingIndex />,
            },
            {
              path: "create",
              element: <CompanyOfferingCreate />,
            },
            {
              path: "detail",
              element: <CompanyOfferingCreate />,
            },
          ],
        },
        {
          path: "operationGuide",
          element: <OperationGuide />,
        },
        {
          index: true,
          element: <Landing />,
        },
        //儀錶板
        {
          path: "dashboard",
          element: <DashboardParent />,
          children: [
            {
              index: true,
              element: <DashboardMain />,
            },
            {
              path: "dataList",
              element: <DataReg_Index />,
            },
          ],
        },
        {
          path: "personalProfile",
          element: <PersonalProfile />,
        },
        {
          path: "changePcode",
          element: <ChangePcode />,
        },
        {
          path: "carbonFootprint",
          element: <Carbon />,
          children: [
            {
              index: true,
              element: <CarbonIndex />,
            },
            {
              path: "dashboard",
              element: <DashboardMain isPlanSn={true} />,
            },
          ],
        },
        {
          path: "companyDataRegistration",
          element: <CompanyDataReg />,
        },
        {
          path: "subAccountSetting",
          element: <SubAccountControl />,
          children: [
            {
              index: true,
              element: <SubAccountIndex />,
            },
            {
              path: "update",
              element: <SubAccountDetail />,
            },
            {
              path: "detail",
              element: <SubAccountDetail />,
            },
          ],
        },
        //碳盤查計畫
        {
          path: "carbonFootprint",
          element: <Carbon />,
          children: [
            {
              index: true,
              element: <CarbonIndex />,
            },
            {
              path: "report",
              children: [
                {
                  index: true,
                  element: <CarbonReport />,
                },
                {
                  path: "editfile",
                  element: <CarbonEditFile />,
                },
              ],
            },
            {
              path: "create",
              children: [
                {
                  index: true,
                  element: <CarbonDetail />,
                },
                {
                  path: "detailCreate",
                  element: <ActivityData_Detail />,
                },
                {
                  path: "detailUpdate",
                  element: <ActivityData_Detail />,
                },
                {
                  path: "evaluationSetting",
                  element: <EvaluationTempSetting />,
                },
              ],
            },
            {
              path: "update",
              children: [
                {
                  index: true,
                  element: <CarbonDetail />,
                },
                {
                  path: "detailCreate",
                  element: <ActivityData_Detail />,
                },
                {
                  path: "detailUpdate",
                  element: <ActivityData_Detail />,
                },
                {
                  path: "evaluationSetting",
                  element: <EvaluationTempSetting />,
                },
              ],
            },
            {
              path: "detail",
              children: [
                {
                  index: true,
                  element: <CarbonDetail />,
                },
                {
                  path: "detailCreate",
                  element: <ActivityData_Detail />,
                },
                {
                  path: "detailUpdate",
                  element: <ActivityData_Detail />,
                },
                {
                  path: "evaluationSetting",
                  element: <EvaluationTempSetting />,
                },
              ],
            },
          ],
        },
        //權限管理
        {
          path: "rolePermission",
          element: <AccessControl />,
          children: [
            {
              index: true,
              element: <AccessControlIndex />,
            },
            {
              path: "funlist",
              element: <RoleFunctionMaintain />,
            },
            {
              path: "group",
              element: <RoleGroup />,
            },
            {
              path: "place",
              element: <RolePlaceMaintain />,
            },
            {
              path: "product",
              element: <RoleProductMaintain />,
            },
          ],
        },
        {
          path: "memberPermissionSetting",
          element: <MemberPermissionSetting />,
        },
        //活動紀錄查詢
        {
          path: "accountActivity",
          element: <AccountActivityControl />,
          children: [
            {
              index: true,
              element: <AccountActivityIndex />,
            },
            {
              path: "detail",
              element: <AccountActivityDetail />,
            },
          ],
        },
        {
          path: "setting",
          element: <Setting />,
          children: [
            {
              index: true,
              element: <SettingIndex />,
            },
            {
              path: "detail",
              element: <SettingDetail />,
            },
          ],
        },
        //碳足跡V1.2
        {
          path: "inventoryCarbonFootprint",
          element: <InventoryCarbonFootprint />,
          children: [
            {
              index: true,
              element: <InventoryCarbonFootprintIndex />,
            },
            {
              path: "dashboard",
              element: <CarbonFootprintDashboard />,
            },
            {
              path: "report",
              children: [
                {
                  index: true,
                  element: <InventoryCarbonFootprintReport />,
                },
                {
                  path: "editfile",
                  element: <InventoryCarbonFootprintEditFile />,
                },
              ],
            },
            {
              path: "detail",
              element: <InventoryCarbonFootprintCreate />,
            },
            {
              path: "create",
              element: <InventoryCarbonFootprintCreate />,
            },
            {
              path: "footprint",
              element: <FootprintInventoryIndex />,
            },
          ],
        },
        //服務碳足跡
        {
          path: "serviceCarbonFootprint",
          element: <ServiceCarbonFootprint />,
          children: [
            {
              index: true,
              element: <ServiceCarbonFootprintIndex />,
            },
            {
              path: "report",
              children: [
                {
                  index: true,
                  element: <CarbonReport />,
                },
                {
                  path: "editfile",
                  element: <CarbonEditFile />,
                },
              ],
            },
            {
              path: "create",
              children: [
                {
                  index: true,
                  element: <CarbonDetail />,
                },
                {
                  path: "detailCreate",
                  element: <ActivityData_Detail />,
                },
                {
                  path: "detailUpdate",
                  element: <ActivityData_Detail />,
                },
              ],
              // },
              // {
              //   path: "update",
              //   children:[
              //     {
              //       index: true,
              //       element: <CarbonDetail />,
              //     },
              //     {
              //       path: "detailCreate",
              //       element: <ActivityData_Detail/>,
              //     },
              //     {
              //       path: "detailUpdate",
              //       element: <ActivityData_Detail/>,
              //     },
              //   ]
              // },
              // {
              //   path: "detail",
              //   children:[
              //     {
              //       index: true,
              //       element: <CarbonDetail />,
              //     },
              //     {
              //       path: "detailCreate",
              //       element: <ActivityData_Detail/>,
              //     },
              //     {
              //       path: "detailUpdate",
              //       element: <ActivityData_Detail/>,
              //     },
              //   ]
            },
          ],
        },
        //產品碳足跡
        {
          path: "productCarbonFootprint",
          element: <ProductCarbonFootprint />,
          children: [
            {
              index: true,
              element: <ProductCarbonFootprintIndex />,
            },
            {
              path: "report",
              children: [
                {
                  index: true,
                  element: <CarbonReport />,
                },
                {
                  path: "editfile",
                  element: <CarbonEditFile />,
                },
              ],
            },
            {
              path: "create",
              children: [
                {
                  index: true,
                  element: <CarbonDetail />,
                },
                {
                  path: "detailCreate",
                  element: <ActivityData_Detail />,
                },
                {
                  path: "detailUpdate",
                  element: <ActivityData_Detail />,
                },
              ],
              // },
              // {
              //   path: "update",
              //   children:[
              //     {
              //       index: true,
              //       element: <CarbonDetail />,
              //     },
              //     {
              //       path: "detailCreate",
              //       element: <ActivityData_Detail/>,
              //     },
              //     {
              //       path: "detailUpdate",
              //       element: <ActivityData_Detail/>,
              //     },
              //   ]
              // },
              // {
              //   path: "detail",
              //   children:[
              //     {
              //       index: true,
              //       element: <CarbonDetail />,
              //     },
              //     {
              //       path: "detailCreate",
              //       element: <ActivityData_Detail/>,
              //     },
              //     {
              //       path: "detailUpdate",
              //       element: <ActivityData_Detail/>,
              //     },
              //   ]
            },
          ],
        },
        {
          path: "analyze",
          element: <ActivityAnalyze />,
          children: [
            {
              index: true,
              element: <ActivityAnalyzeIndex />,
            },
            {
              path: "detail",
              element: <CompanyBindingDetail backToUrl="analyze" />,
            },
            {
              path: "userDashboard",
              element: <UserDashboardIndex />,
            },
          ],
        },
        // 設備製成設定
        {
          path: "equipmentProcessSettings",
          element: <EquipmentProcessSettings />,
          children: [
            {
              index: true,
              element: <EquipmentProcessSettingsIndex />,
            },
            {
              path: "detail",
              element: <EquipmentProcessSettingsDetail />,
            },
          ],
        },
        // 產品製成設定
        {
          path: "productProcessSettings",
          element: <ProductProcessSettings />,
          children: [
            {
              index: true,
              element: <ProductProcessSettingsIndex />,
            },
            {
              path: "detail",
              element: <ProductProcessSettingsDetail />,
            },
          ],
        },
        // cbam 盤查
        {
          path: "cbam",
          element: <Cbam />,
          children: [
            {
              index: true,
              element: <CbamIndex />,
            },
            {
              path: "create",
              element: <CbamDetail />,
            },
            {
              path: "detail",
              element: <CbamDetail />,
            },
          ],
        },
        {
          path: "companyStatsList",
          element: <CompanyStatsList />,
          children: [
            {
              index: true,
              element: <CompanyStatsListIndex />,
            },
            {
              path: "detail",
              element: <CompanyStatusListDetail backToUrl="companyStatsList" />,
            },
          ],
        },
        {
          path: "userDashboard",
          element: <UserDashboard />,
          children: [
            {
              index: true,
              element: <UserDashboardIndex />,
            },
          ],
        },
        {
          path: "cache",
          element: <Cache />,
          children: [
            {
              index: true,
              element: <CacheIndex />,
            },
          ],
        },
        {
          path: "emissionSourceFactor",
          element: <EmissionSourceFactor />,
        },
        {
          path: "boundaryDevice",
          element: <BoundaryDevice />,
          children: [
            {
              index: true,
              element: <BoundaryDeviceIndex />,
            },
            {
              path: "detail",
              element: <BoundaryDeviceDetail />,
            },
          ],
        },
        {
          path: "*",
          element: <NotFound />,
        },
      ],
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ]);

  return routes;
};

export default HandleRoutesPath;
